<template>
  <DocumentCenterModal
    :download="store.download"
    :open="open"
    :preferred-locales="preferredLocales"
    @abort="onAbort"
    @after-close="onAfterClose"
  />
</template>

<script setup lang="ts">
import { useDownloadStore } from '~/stores/downloadStore/downloadStore';
import DocumentCenterModal from './DocumentCenterModal.vue';
import { DOWNLOAD_LOCALE_CONTENTFUL_LOCALE_MAP } from '~/lib/DownloadService/constants';
import { isDefined } from '~/utils/guards/isDefined';
import type { ContentfulLocaleCode } from '~/lib/ContentfulService/model';

const store = useDownloadStore();

const props = defineProps<{
  abortFunction?: () => void;
  afterCloseFunction?: () => void;
}>();

const open = computed(
  () => store.activeModal === true || typeof store.activeModal === 'string'
);
const preferredLocales = computed<ContentfulLocaleCode[] | undefined>(() =>
  store.filters['medialink.locale']
    ?.map((locale) => DOWNLOAD_LOCALE_CONTENTFUL_LOCALE_MAP[locale])
    .filter(isDefined)
);

const onAbort = () => {
  if (props.abortFunction) {
    props.abortFunction();
  } else {
    store.closeModal();
  }
};

const onAfterClose = () => {
  if (props.afterCloseFunction) {
    props.afterCloseFunction();
  } else {
    store.afterCloseModal();
  }
};

watch(
  () => store.download,
  () => {
    if (store.download && store.activeModal === true) {
      store.activeModal = store.download.id;
    }
  }
);
</script>
